export default "__VITE_PUBLIC_ASSET__ed3a6ae8__"